export const DEFAULT_FILTERS = {
    run_date: null,
    policy_code: '',
    partner_id: '',
    company_name: '',
    reservation_number: '',
    activity_name: '',
    distribution_type: '',
    include_completed: true,
    forecast_timing_hour: null,
    match_current_hour: false,
    scope: 'all',
    observation_timing_hour: null,
    trip_end_date_from: null,
    trip_end_date_to: null,
};

export const FORECAST_PAGE_SIZE_OPTIONS = [20, 50, 100];
export const DEFAULT_FORECAST_PAGE_SIZE = 50;
export const FORECAST_TABLE_MAX_ROWS = 5;

export const DISTRIBUTION_TYPE_OPTIONS = [
    { value: '', label: 'Tous' },
    { value: 'inclusion', label: 'Inclusion' },
    { value: 'option', label: 'Option' },
    { value: 'b2c', label: 'B2C' },
];

export const OBSERVATION_SCOPE_OPTIONS = [
    { value: 'all', label: 'Tous' },
    { value: 'claims', label: 'Sinistres' },
    { value: 'forecast_not_triggered', label: 'Prévisions non déclenchées' },
];

export const FORECAST_HOUR_OPTIONS = Array.from({ length: 24 }, (_, hour) => ({
    value: String(hour),
    label: `${hour}h`,
}));

export const END_OF_STAY_SCOPE_OPTIONS = [
    { value: 'all', label: 'Tous' },
    { value: 'aloa', label: 'Aloa' },
    { value: 'lacdesgraves', label: 'Lac des Graves' },
    { value: 'flower', label: 'Flower' },
];

export const END_OF_STAY_SECTION_KEYS = ['aloa', 'lacdesgraves', 'flower'];
